import { INSURANCE_TYPES } from '../../../../../constants';
import InsuranceForm from './insurance';

export default function PrimaryInsuranceForm() {
  return <InsuranceForm insuranceType={INSURANCE_TYPES.PRIMARY} />;
}
